import { Dialog } from './components/dialog';
import { BrowserApp } from '../../../business/common/browser';

export function BrowserDialog() {
  return <Dialog showCloseButton={true} />;
}
